export default {
  toolBox: {
    title: "Helpful Tip",
    text: "This profile can populate the following:",
    formsArray: [
      {
        formCommonName: "H-2B LABOR CERTIFICATION",
        formGovName: "FORM ETA-9142B",
        sections: ["APPENDIX C"],
      },
      {
        formCommonName: "H-2A TEMPORARY LABOR CERTIFICATION",
        formGovName: "FORM ETA-9142A",
        sections: ["APPENDIX D"],
      },
    ],
  },
};
